angular.module('common.directives').directive('adOnMdDrag', function () {
  return {
    restrict: 'A',
    link: function (scope, elem) {
      const wrappger = angular.element(
        elem[0].getElementsByClassName('md-slider-wrapper')
      )
      wrappger.on('$md.drag', function (e) {
        scope.onMdDrag(e)
      })
    }
  }
})
